import type { Config } from "../../../aysa_api/models/config.types";
import type { OptionalCustomerSession } from "../../../aysa_api/models/session.types";
import type { TargetGroup } from "../../../aysa_api/models/target_group.types";
import type { SponsoredContentSection } from "../../../aysa_api/models/sections.types";
import type { RichText } from "../../../aysa_api/models/rich_text.types";

export enum GetSponsoredSectionsRequest_TargetType {
  UNSPECIFIED = 0,
  SEARCH_SUGGESTION = 1,
}

export interface GetSponsoredSectionsRequest {
  config: Config;
  session?: OptionalCustomerSession;
  targetType: GetSponsoredSectionsRequest_TargetType;
  targetGroup: TargetGroup;
}

export interface GetSponsoredSectionsResponse {
  section: SponsoredContentSection[];
}

export interface SponsorshipInfoRequest {
  config: Config;
  target: SponsorshipInfoRequest_Target;
}

export interface SponsorshipInfoRequest_Target {
  type?:
    | {
        $case: "productId";
        productId: number;
      }
    | {
        $case: "promotionId";
        // from [PromotionTracker.promotion_id]
        promotionId: string;
      };
}

export interface SponsorshipInfoResponse {
  headline: string;
  body: RichText;
}
